export const PAID_PLANS = ['BUSINESS', 'UNLIMITED', 'PREMIUM'];

export const APP_SUMO_PLAN = 'PROFESSIONAL';

export const CHAT_ELIGIBLE_PLANS = [
  'PREMIUM',
  'BUSINESS',
  'UNLIMITED',
  'PROFESSIONAL',
  'MOBILE_PRO',
  'FILMR_PRO',
];

export const FREE_PASS_LIMIT = 0;
